import React, { useContext } from 'react';
import FiltersHeader from './FiltersHeader';
import ArticleFilters from '../ArticleFilters';
import CompanyFilters from '../CompanyFilters';
import EventFilters from '../EventFilters';
import MemberFilters from '../MemberFilters';
import CurrentFilters from '../../elements/CurrentFilters';
import { SearchTypeContext } from '../../../context/searchTypeContext';

const FiltersSidebar = () => {
    const [searchType] = useContext(SearchTypeContext);

    return (
        <div className="p-md-4 py-md-4">
            <div className="pb-3" style={styles.header}>
                <FiltersHeader />
                <CurrentFilters buttonClasses="display9" clearAllClasses="display9" />
            </div>

            {searchType.index === 'members' && <MemberFilters />}
            {searchType.index === 'member_events' && <MemberFilters />}
            {searchType.index === 'companies' && <CompanyFilters />}
            {searchType.index === 'articles' && <ArticleFilters />}
            {searchType.index === 'events' && <EventFilters />}
        </div>
    );
};

const styles = {
    container: {
        paddingLeft: '3rem',
    },
    header: {
        borderBottom: '1px solid #000',
    },
};

export default FiltersSidebar;
